import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import { DialogContent } from '@mui/material';
import { Grid } from '@mui/material';
import SignatureCard from './SignatureCard';
import CustomAgGrid from '../commoncomponents/CustomAgGrid';
import axios from 'axios';
import { BemsGraph, FemsGraph, MasterGraph } from '../../utility/apiURLS';
import { getAuthToken } from '../../utility/tokenUtility';
import { useSelector } from 'react-redux';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import dayjs from 'dayjs';
import CustomAlert from '../userlocationcomponents/CustomAlert';

function AddRowButton({ onClick, isViewPage }) {
  const handleClick = () => {
    onClick();
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
      {!isViewPage && (
        <Button color="primary" variant="contained" startIcon={<AddIcon />} onClick={handleClick}>
          Add Row
        </Button>
      )}
    </Box>
  );
}

export default function SignatureUpload({ handleSaveSignature, rows, setRows, openDialog, setOpenDialog }) {
  const [gridApi, setGridApi] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [isSignatureAffected, setIsSignatureAffected] = useState(false);
  const [getByIdSignatures, setGetByIdSignatures] = useState([]);
  const [gridLoader, setGridLoader] = useState(false);
  const [confrimDialoug, setConfrimDialoug] = useState(false);
  const [currentId, setCurrentId] = useState(false);
  // Get the basic details from the Redux store
  const basicDetails = useSelector(state => state.TestingCommissionDetails.basicDetails);
  const tcDetails = useSelector(state => state.TestingCommissionDetails.tcDetails);
  const isViewPage = tcDetails?.isViewMode;
  const columns = [
    {
      field: 'signature',
      headerName: 'Signature',
      minWidth: 200,
      width: 160,
      cellRenderer: (params) => (
        <Button onClick={() => handleSignatureUpload(params.data.id)} disabled={isViewPage || ((params?.data?.file?.type || params?.data?.fileType) ? true : false)}>
          {(params?.data?.file?.type || params?.data?.fileType) ? 'Signature Uploaded' : 'Upload Signature'}
        </Button>
      ),
    },
    { field: 'name', headerName: 'Name', width: 150 },
    { field: 'designation', headerName: 'Designation', width: 150 },
    { field: 'fileType', headerName: 'File Type', width: 150 },
    { field: 'size', headerName: 'Size', width: 130},
    { field: 'date', headerName: 'Date', width: 130 },
    {
      field: 'actions',
      headerName: 'Actions',
      minWidth: 180,
      cellRenderer: (params) => (
        <>
          <Button disabled={isViewPage} onClick={() => handleConfrimDelete(params?.data)}>
            <DeleteIcon />
          </Button>
          {(params?.data?.file?.type || params?.data?.fileType) &&
            <Button onClick={() => handleDownload(params?.data?.fileSignature || params?.data?.filename)}>
              <FileDownloadIcon />
            </Button>
          }
        </>
      ),
    },
  ];

  const fetchFormData = async () => {
    try {
      setGridLoader(true);
      const config = {
        headers: {
          Authorization: `Bearer ${getAuthToken('id_token')}`,
        },
      };
      const serviceType = basicDetails?.service?.label;
      const id = basicDetails?.id;
      const url = serviceType === "FEMS" ? `${FemsGraph}/api/TestingandCommission/GetTestingsignatureList/${id}` : `${BemsGraph}/api/TestingandCommission/GetTestingsignatureListbem/${id}`;
      const response = await axios.get(`${url}`, config);
      if (response?.data?.length > 0) {
        setGetByIdSignatures(response?.data);
        const rowsData = response.data.map((item) => ({
          id: item?.id,
          name: item?.username || '',
          designation: item?.designation || '',
          fileType: item?.documenttype || '',
          size: item?.filesize || '',
          date: dayjs(item?.signaturedate).format('DD-MM-YYYY') || '',
          signature: item?.signature || '',
          fileSignature: item?.signaturefile || '',
          filename: item?.filename || '',
        }));
        setRows(rowsData);
      } else {
        setRows([
          {
            id: 1,
            name: '',
            designation: '',
            fileType: '',
            size: '',
            date: '',
            signature: '',
            fileSignature: '',
          }
        ]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setGridLoader(false);
    }
  };
  useEffect(() => {
    const id = basicDetails?.id;
    if (id) {
      fetchFormData();
    }
  }, [isSignatureAffected]);

  const handleDownload = async (file) => {
    if (file && (file instanceof Blob || file instanceof File)) {
      const url = URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name ? file.name : 'signature';
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(url);
    } else {
      const id = file;
      const config = {
        headers: {
          Authorization: `Bearer ${getAuthToken('id_token')}`,
        },
      }
      const response = await axios.get(`${MasterGraph}/api/FileUpload/DownloadFile/${id}`, {
        ...config,
        responseType: 'blob'
      });
      const url = URL.createObjectURL(response.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name ? file.name : 'signature';
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(url);
    }
  };

  function handleSaveSignature(id, data) {
    const updatedRows = rows.map((row) =>
      row.id === id ? { ...row, ...data, fileSignature: data.file } : row
    );
    setRows(updatedRows);
    setOpenDialog(false); // Close the dialog box
    return updatedRows;
  };

  const handleConfrimDelete = (row) => {
    const id = row?.id;
    if (row?.fileType !== '') {
      setCurrentId(id);
      setConfrimDialoug(true);
    } else {
      handleDeleteClick(id);
    }
  }

  const handleDeleteClick = async (id) => {
    const fetchedFiles = getByIdSignatures?.find((item) => item?.id === id);
    if (getByIdSignatures.length > 0 && fetchedFiles) {
      try {
        const serviceType = basicDetails?.service?.label;
        const url = serviceType === "FEMS" ? FemsGraph : BemsGraph;
        const femorbem = serviceType === "FEMS" ? "femtestingcommissionsignatures" : "bemtestingcommissionsignatures";
        const config = {
          headers: {
            Authorization: `Bearer ${getAuthToken('id_token')}`,
          },
        }
        const response = await axios.delete(`${url}/api/${femorbem}/${id}`, config);
        if (response) {
          setIsSignatureAffected(true);
          fetchFormData();
        }
      } catch (error) {
        console.log("Error deleting item:", error);
      }
    } else if (rows?.length > 1) {
      const updatedRows = rows.filter((row) => row.id !== id);
      setRows(updatedRows);
    } else if (rows?.length === 1) {
      const index = rows?.findIndex((item) => item?.id === id);
      if (!rows[index]?.name) {
        return;
      } else {
        setRows([
          {
            id: 1,
            name: '',
            designation: '',
            fileType: '',
            size: '',
            date: '',
            signature: '',
            fileSignature: '',
          }
        ])
      }
    }
  };

  const handleAddRow = () => {
    const id =
      rows.length > 0
        ? Math.max(...rows.map((row) => (isNaN(row.id) ? 0 : Number(row.id)))) + 1
        : 1;
    const newRow = {
      id: id, // Convert to string to match initial row's ID format
      category: '',
      fileType: '',
      designation: '',
      size: '',
    };
    setRows((oldRows) => [...oldRows, newRow]);
  };

  const handleSignatureUpload = (id) => {
    setSelectedRowId(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <Grid sx={{ marginBottom: '2rem' }}>
        <Typography variant="subtitle1" align="left">Add Signature</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="body1" gutterBottom>
            {/* Please add files in formate of doc, jpg, png, pdf. */}
          </Typography>
          <AddRowButton onClick={handleAddRow} isViewPage={isViewPage} />
        </Box>
      </Grid>
      <CustomAgGrid
        rows={rows}
        columns={columns}
        setGridApi={setGridApi}
        isLoading={gridLoader}
      />
      <Dialog
        open={openDialog}
        onClose={(event, reason) => {
          if (reason === "backdropClick") {
            // Prevent closing the dialog on backdrop click
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown
      >
        <DialogContent>
          <SignatureCard
            onCancel={handleCloseDialog}
            onClear={handleCloseDialog}
            onSave={(data) => {
              const updatedRows = handleSaveSignature(selectedRowId, data);
              if (updatedRows) {
                fetchFormData();
              }
            }}
            rowData={rows.find((row) => row.id === selectedRowId)}
          />
        </DialogContent>
      </Dialog>
      <CustomAlert
        open={confrimDialoug}
        onConfirm={() => {
          handleDeleteClick(currentId)
          setConfrimDialoug(false)
        }}
        content={"Are you sure want to delete?"}
        onClose={() => setConfrimDialoug(false)}
        cancelBtn={"NO"}
        confirmBtn={"YES"}
      />
    </>
  );
}
